import cn from 'classnames';
import styles from './StateText.module.scss';
import { Icon } from '../Icon';

interface StateTextI {
  children?: string | string[];
  className?: string;
  type?: 'info';
}

export const StateText = ({
  children,
  className,
  type = 'info',
}: StateTextI) => {
  return (
    <div className={cn(styles.root, className, styles[type])}>
      <Icon type="info" />
      <p>{children}</p>
    </div>
  );
};
